import React from 'react'

import CustomerTable from './CustomerTable'

const RetrieveCustomer = ({ cyclists }) => {
  return <CustomerTable cyclists={cyclists} />
}

export default RetrieveCustomer
